import { render, staticRenderFns } from "./HubKpiSettings.vue?vue&type=template&id=5bda55bf"
import script from "./HubKpiSettings.vue?vue&type=script&lang=js"
export * from "./HubKpiSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports